<template>
  <div
    v-if="buildCrumbs.length > 0"
    class="breadcrumb"
    :class="{ 'background': $route.name === 'ManifestationService' }"
  >
    <router-link
      class="home"
      :to="{ name: 'Home' }"
    >
      Início
    </router-link>
    <div
      v-for="crumb in buildCrumbs"
      :key="crumb.name"
      class="link"
    >
      <span class="link__dash"> / </span>
      <router-link
        class="link__text"
        :to="crumb.path"
      >
        {{ $t(crumb.name) }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',

  computed: {
    buildCrumbs(){
      let crumbs = [];

      if(this.$route.meta.breadcrumb) {
        this.$route.meta.breadcrumb.forEach(crumb => {
          crumbs.push({
            name: crumb.name,
            path: crumb.path
          });
        });
      }

      let params = this.$route.params;
      let paramKeys = Object.keys(params);

      paramKeys.forEach(key => {
        for(let index in crumbs) {
          if(typeof crumbs[index].path === 'number') {
            crumbs[index].path = crumbs[index].path.toString();
          }else if(crumbs[index].path.replace(':', '') === key) {
            crumbs[index].path = params[key];
          }
        }
      });

      return crumbs;
    },
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  display: none;
  width: 100%;
  padding: 1.25rem max(4%, calc(50% - $max-width-mobile/2)) 1rem;
  font-size: $text-xs;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @include screen(phone-up) {
    display: block;
    padding: 1rem 4%;
  }

  @include screen(tablet-big-up) {
    padding: 1.25rem max(8%, calc(50% - $max-width-desktop/2)) 1rem;
  }

  .home {
    font-weight: $font-bold;
    color: $secondary;
  }

  .link {
    display: inline;
    font-weight: $font-bold;
    color: $secondary;

    &__dash {
      font-weight: $font-normal;
      color: $gray-breadcrumb;
    }

    &:last-child {
      a {
        font-weight: $font-regular;
        color: $gray-breadcrumb;
      }
    }
  }

  @media print {
    display: none;
  }
}

.background {
  background-color: $primary-light;
}
</style>
